import graphql__c9af447e255152bd79bc from "./__generated__/EventCard_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import compact from "lodash/compact";

import ButtonLink from "../Buttons/ButtonLink";
import parseDate from "../Utils/parseDate";
import Icon from "../Utils/Icon";
import { useFormatDate, useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";

const EventCard = props => {
  const participativeModule = useFragment(
    EventCard_participativeModule,
    props.participativeModule
  );
  const {
    visualization: event,
    title,
    slug: participativeModuleSlug
  } = participativeModule;
  const { startsAt, placeName, address, zip, city } = event;

  const t = useFormatMessage();
  const see = t(intlMessages.see);

  const { pathFor } = useRoutesContext();
  const eventPath = pathFor("participativeModule", { participativeModuleSlug });

  const formatDate = useFormatDate();
  const startsAtDate = parseDate(startsAt);
  const startWeekday = formatDate(startsAtDate, { weekday: "long" }, false);
  const startDay = formatDate(startsAtDate, { day: "2-digit" }, false);
  const startMonth = formatDate(startsAtDate, { month: "long" }, false);
  const startYear = formatDate(startsAtDate, { year: "numeric" }, false);

  const hasAddress = placeName || address || city;
  const cityText = hasAddress && (zip || city) && compact([zip, city]).join(" ");
  const fullAddressText =
    hasAddress && (address || cityText) && compact([address, cityText]).join("<br />");

  return (
    <div className="card box box-shadow box-image h-100">
      <div className="items-group flex-1">
        <div className="card-panel items-group-addon padding-sm margin-bottom-xs margin-right-xs text-center justify-content-center d-flex flex-column">
          <div className="weekday text-title-page">{startWeekday}</div>
          <div className="day text-number-xxl">{startDay}</div>
          <div className="month text-title-page">{startMonth}</div>
          <div className="year text-title-page">{startYear}</div>
        </div>

        <div className="d-flex flex-column padding-sm card-panel margin-bottom-xs items-group-main">
          <div className="title flex-1 d-flex align-items-center text-title-overview">
            {title}
          </div>

          {hasAddress && (
            <div className="with-icon" title={fullAddressText}>
              <Icon className="icon-map-marker event-map-icon text-primary text-metric-md" />

              <div className="with-icon-text text-small">
                {placeName && <div className="placeName">{placeName}</div>}

                {address && <div className="address">{address}</div>}
                {city && <div className="city">{cityText}</div>}
              </div>
            </div>
          )}
        </div>
      </div>

      <ButtonLink
        href={eventPath}
        className="btn btn-primary btn-block-md card-footer border-radius"
        label={see}
        iconClassName="icon-arrow-right"
        iconPosition="after"
      />
    </div>
  );
};

const EventCard_participativeModule = graphql__c9af447e255152bd79bc;

export default EventCard;

const intlMessages = defineMessages({
  see: {
    id: "event.card.see",
    defaultMessage: "Voir l'évènement"
  }
});
